import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
// @mui
import {
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import Iconify from "../../components/Iconify";
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from "../../hooks/useResponsive";
// utils
import axios from '../../utils/axios';


// ----------------------------------------------------------------------

export default function RequestUpdateProfileDialogButton({ profile, freeSolo=false }) {
  const smUp = useResponsive("up", "sm");
  const { user } = useAuth();
  const [isSubmit, setIsSubmit] = useState(false);
  const [step, setStep] = useState(0);  // 0, 1
  const [open, setOpen] = useState(false);
  const disabled = profile?.coffee_chat_ing;

  const confirmStep = step === 0;
  const done = step === 1;

  const { enqueueSnackbar } = useSnackbar();

  const requestUpdateProfile = async () => {
    setOpen(true);
  };

  useEffect(() => {
    if (!open) {
      setStep(0);
    }
  }, [open]);

  const submit = async () => {
    setIsSubmit(true);
    const companyId = user?.employee.company[0].id;
    try {
      const crewId = profile?.id;
      await axios.post(`/api/company/${companyId}/scout/${crewId}/request-profile/`);
      setIsSubmit(false);
      setStep(1);
    } catch (error) {
      setIsSubmit(false);
      if (error.response && error.response.status === 400) {
        enqueueSnackbar(error.response.data.message, { variant: 'error' });
      } else {
        enqueueSnackbar("저장에 실패하였습니다. 관리자에 문의해주세요.", { variant: 'error' });
      }
    }
  };

  return (
    <>
    <LoadingButton
      size={"medium"}
      variant={freeSolo ? "contained" : "outlined"}
      color={freeSolo ? "primary" : "inherit"}
      sx={{
        px: 1.5,
        ...!freeSolo && {
          color: "text.secondary",
          borderColor: "rgba(145, 158, 171, 0.32)",
        }
      }}
      onClick={requestUpdateProfile}
      disableRipple
      disabled={disabled}
      loading={isSubmit}
    >
      프로필 작성 요청하기
    </LoadingButton>
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="dg" sx={{ p: 0 }}>
      {done ? (
        <DialogContent
        sx={{ p: { xs: 3, sm: 4 } }}
      >
        <Iconify icon={"eva:checkmark-circle-2-fill"} sx={{ width: 24, height: 24, color: 'success.main' }} />
        <Typography variant="h5" paragraph>
          크루에게 프로필/이력을 더 작성해달라고 요청했어요
        </Typography>
      </DialogContent>
      ) : (
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        <Typography variant="h5" paragraph>
          크루에게 프로필/이력을 더 작성해달라고 요청할까요?
        </Typography>
      </DialogContent>
      )}
      <DialogActions
        sx={{ m: { xs: 0, sm: 1 }, pt: "0!important" }}
      >
        <Stack direction={smUp ? "row" : "column-reverse"} spacing={2} sx={{ width: 1 }} justifyContent="flex-end">
        <LoadingButton
          variant={done ? "contained" : "text"}
          size="large"
          onClick={() => setOpen(false)}
          loading={isSubmit}
          fullWidth={!smUp}
          sx={{ px: 4 }}
        >
          {done ? '확인했어요' : '취소'}
        </LoadingButton>
        {confirmStep && (
          <LoadingButton
            variant="contained"
            size="large"
            fullWidth={!smUp}
            onClick={() => submit()}
            sx={{ px: 6 }}
            loading={isSubmit}
          >
            요청하기
          </LoadingButton>
        )}
        </Stack>
      </DialogActions>
    </Dialog>
    </>
  )
};